/**
 * 基础菜单 商品管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>报告列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search" ref="formInline">
      <el-form-item label="搜索：" prop="samplesNumber">
        <el-input size="small" v-model="formInline.samplesNumber" placeholder="输入样品编号"></el-input>
      </el-form-item>
      <el-form-item label="" prop="reportNumber">
        <el-input size="small" v-model="formInline.reportNumber" placeholder="输入报告编号"></el-input>
      </el-form-item>
      <el-form-item label="" prop="unit">
        <el-input size="small" v-model="formInline.unit" placeholder="输入委托单位"></el-input>
      </el-form-item>
      <el-form-item label="" prop="projectName">
        <el-input size="small" v-model="formInline.projectName" placeholder="输入工程名称"></el-input>
      </el-form-item>
      <el-form-item label="" prop="samplesNmae">
        <el-input size="small" v-model="formInline.samplesNmae" placeholder="输入样品名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-search" @click="resetSearchForm('formInline')">重置</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <!-- <el-table-column align="center" type="selection" width="60">
      </el-table-column> -->
      <el-table-column sortable prop="samplesNumber" label="样品编号" >
      </el-table-column>
      <el-table-column sortable prop="reportNumber" label="报告编号" >
      </el-table-column>
      <el-table-column sortable prop="unit" label="委托单位" >
      </el-table-column>
      <el-table-column sortable prop="projectName" label="工程名称">
      </el-table-column>
      <el-table-column sortable prop="samplesNmae" label="样品名称" >
      </el-table-column>
      <el-table-column sortable prop="specification" label="型号规格" >
      </el-table-column>
      <el-table-column sortable prop="date" label="委托日期" >
        <!-- <template slot-scope="scope">
          <div>{{scope.row.editTime|timestampToTime}}</div>
        </template> -->
      </el-table-column>
      <el-table-column sortable prop="pdyj" label="判定依据" >
      </el-table-column>
      <el-table-column sortable prop="jconclusion" label="检测结论" >
      </el-table-column>
      <el-table-column sortable prop="jcxm" label="检测项目" >
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="150">
        <template slot-scope="scope">
          <el-button size="mini" @click="creqrcode(scope.$index, scope.row)">二维码</el-button>
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <!-- <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination> -->
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @close="closeDialog">
        <el-form ref="editForm" :model="editForm" :rules="rules" label-width="90px" >
        <el-form-item label="样品编号">
            <el-input v-model="editForm.samplesNumber"></el-input>
        </el-form-item>
        <el-form-item label="报告编号">
            <el-input v-model="editForm.reportNumber"></el-input>
        </el-form-item>
        <el-form-item label="委托单位">
            <el-input v-model="editForm.unit"></el-input>
        </el-form-item>
        <el-form-item label="工程名称">
            <el-input v-model="editForm.projectName"></el-input>
        </el-form-item>
        <el-form-item label="样品名称">
            <el-input v-model="editForm.samplesNmae"></el-input>
        </el-form-item>
        <el-form-item label="型号规格">
            <el-input v-model="editForm.specification"></el-input>
        </el-form-item>
        <el-form-item label="委托日期">
            <el-date-picker
            value-format="yyyy/MM/dd"
                v-model="editForm.date"
                type="date"
                placeholder="选择日期">
            </el-date-picker>
        </el-form-item>
        <el-form-item label="判定依据">
            <el-input v-model="editForm.pdyj"></el-input>
        </el-form-item>
        <el-form-item label="检测结论">
            <el-input v-model="editForm.jconclusion"></el-input>
        </el-form-item>
        <el-form-item label="检测项目">
            <el-input v-model="editForm.jcxm"></el-input>
        </el-form-item>

        <!-- <el-form-item>
            <el-button type="primary" @click="onSubmit('form')">立即创建</el-button>
            <el-button>取消</el-button>
        </el-form-item>
    </el-form>
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item label="部门名称" prop="deptName">
          <el-input size="small" v-model="editForm.deptName" auto-complete="off" placeholder="请输入部门名称"></el-input>
        </el-form-item>
        <el-form-item label="部门代码" prop="deptNo">
          <el-input size="small" v-model="editForm.deptNo" auto-complete="off" placeholder="请输入部门代码"></el-input>
        </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="editFormVisible = false">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>
     <!-- 编辑界面 -->
     <el-dialog  :title="title1" :visible.sync="qrcode1" width="15%"  @click="closeDialogCode">
      <div ref="qrcode11" id="qrcode11" ></div>
      <!-- <qrcode :Msg=this.reportNumber  ></qrcode> -->
     </el-dialog>
     <!-- <div id="qrcode" v-if="qrcode1" ref="expCodeRef" style="position: absolute;margin: auto ;
      left:50%;"></div> -->
  </div>
</template>

<script>
import { deptList, deptSave, deptDelete } from '../../api/userMG'
import Pagination from '../../components/Pagination'
import {ReportList,CreateReport,UpdateReport,delReport,FindReportList} from '../../api/report'
import Qrcode from '../../components/qrcode.vue'
import QRCode from 'qrcodejs2'

export default {
  data() {
    return {
      reportNumber:'',
      qrcode1: false,//控制二维码页面显示与隐藏
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      flag: true, //控制新增或修改
      title: '添加',
      title1: '报告详情二维码',
      editForm: {
          samplesNumber: '',
          reportNumber: '',
          unit: '',
          projectName: '',
          samplesNmae: '',
          specification: '',
          date: '',
          pdyj: '',
          jconclusion: '',
          jcxm: ''
      },
      // rules表单验证
      rules: {
        samplesNumber: [
            { required: true, message: '请输入名称', trigger: 'blur' }
            ],
            reportNumber: [{ required: true, message: '请输入', trigger: 'blur' }]
      },
      formInline: {
        reportNumber: '',
        samplesNmae: '',
        projectName: '',
        unit: '',
        samplesNumber: ''

        // page: 1,
        // limit: 10,
        // varLable: '',
        // varName: '',
        // token: localStorage.getItem('logintoken')
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination,
    Qrcode,
    QRCode

  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    //重置搜索框
    resetSearchForm(formName) {
        this.$refs[formName].resetFields();
        this.getdata(null);
    },
    creqrcode(index,row){
      this.qrcode1 = true;
      // console.log("sasa" + row.reportNumber)
      // this.reportNumber=row.reportNumber
      // this.delQrcode()
      this.$nextTick(() => {
        var url = window.location.href;
        console.log("caaca" + url);
        this.$refs.qrcode11.innerHTML = ""
        new QRCode("qrcode11", {
          width: 150,
          height: 150,
          text: "http://www.tyjc3935.com/#/scanQRCode/"+row.reportNumber,
        });
      });
    },

    // 获取报告列表
    getdata(parameter) {
      this.loading = true
      // 模拟数据开始
      // let res = {
      //   code: 0,
      //   msg: null,
      //   count: 5,
      //   data: [
      //     {
      //       addUser: null,
      //       editUser: null,
      //       addTime: 1521062371000,
      //       editTime: 1526700200000,
      //       deptId: 2,
      //       deptName: 'XX分公司',
      //       deptNo: '1',
      //       parentId: 1
      //     },
      //     {
      //       addUser: null,
      //       editUser: null,
      //       addTime: 1521063247000,
      //       editTime: 1526652291000,
      //       deptId: 3,
      //       deptName: '上海测试',
      //       deptNo: '02',
      //       parentId: 1
      //     },
      //     {
      //       addUser: null,
      //       editUser: null,
      //       addTime: 1526349555000,
      //       editTime: 1526349565000,
      //       deptId: 12,
      //       deptName: '1',
      //       deptNo: '11',
      //       parentId: 1
      //     },
      //     {
      //       addUser: null,
      //       editUser: null,
      //       addTime: 1526373178000,
      //       editTime: 1526373178000,
      //       deptId: 13,
      //       deptName: '5',
      //       deptNo: '5',
      //       parentId: 1
      //     },
      //     {
      //       addUser: null,
      //       editUser: null,
      //       addTime: 1526453107000,
      //       editTime: 1526453107000,
      //       deptId: 17,
      //       deptName: 'v',
      //       deptNo: 'v',
      //       parentId: 1
      //     }
      //   ]
      // }
      // this.loading = false
      // this.listData = res.data
      // this.pageparm.currentPage = this.formInline.page
      // this.pageparm.pageSize = this.formInline.limit
      // this.pageparm.total = res.count
      // 模拟数据结束

      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
       ReportList()
        .then(res => {
          this.loading = false
          if (res.code != 0) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.listData = res.report
            // 分页赋值
            // this.pageparm.currentPage = this.formInline.page
            // this.pageparm.pageSize = this.formInline.limit
            // this.pageparm.total = res.count
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('数据加载失败，请稍后再试！')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    getFindData(parameter) {
      this.loading = true
      FindReportList(parameter)
        .then(res => {
          this.loading = false
          if (res.code != 0) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.listData = res.date
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('数据加载失败，请稍后再试！')
        })
    },
    // 搜索事件
    search() {
      let obj = this.formInline;
      let formData = new FormData();
        Object.keys(obj).map((key) => {
          // if(obj[key] != null || obj[key] != ''){
            formData.append(key, obj[key]);
          // }
      });
      this.getFindData(formData);
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.flag = true
        this.title = '修改';
        this.editForm.samplesNumber = row.samplesNumber;
        this.editForm.reportNumber = row.reportNumber;
        this.editForm.unit = row.unit;
        this.editForm.projectName = row.projectName;
        this.editForm.samplesNmae = row.samplesNmae;
        this.editForm.specification = row.specification;
        this.editForm.date = row.date;
        this.editForm.pdyj = row.pdyj;
        this.editForm.jconclusion = row.jconclusion;
        this.editForm.jcxm = row.jcxm;
        //处理无法修改问题
        this.editForm = JSON.parse(JSON.stringify(this.editForm));
        
      } else {
        this.flag = false;
        this.title = '添加'
        this.editForm.samplesNumber = null;
        this.editForm.reportNumber = null;
        this.editForm.unit = null;
        this.editForm.projectName = null;
        this.editForm.samplesNmae = null;
        this.editForm.specification = null;
        this.editForm.date = null;
        this.editForm.pdyj = null;
        this.editForm.jconclusion = null;

      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      if(this.flag){//修改
        this.$refs[editData].validate(valid => {
          if (valid) {
              UpdateReport(this.editForm)
              .then(res => {
                this.editFormVisible = false
                this.loading = false
                if (res.code == 0) {
                  this.getdata(this.formInline)
                  this.$message({
                    type: 'success',
                    message: '修改保存成功！'
                  })
                } else {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                }
              })
              .catch(err => {
                this.editFormVisible = false
                this.loading = false
                this.$message.error('修改保存失败，请稍后再试！')
              })
          } else {
            return false
          }
        })
      }else{//新增
        this.$refs[editData].validate(valid => {
          if (valid) {
              CreateReport(this.editForm)
              .then(res => {
                if (res.code == 0) {
                  this.editFormVisible = false
                  this.loading = false
                  this.getdata(this.formInline)
                  this.$message({
                    type: 'success',
                    message: '创建成功！'
                  })
                } else {
                  this.$message({
                    type: 'info',
                    message: res.message
                  })
                }
              })
              .catch(err => {
                this.editFormVisible = false
                this.loading = false
                this.$message.error('创建失败，请稍后再试！')
              })
          } else {
            return false
          }
        })
      }
    },
    //清空
    clearForm(){
        this.form.samplesNumber = null;
          this.editForm.reportNumber = null;
          this.editForm.unit = null;
          this.editForm.projectName = null;
          this.editForm.samplesNmae = null;
          this.editForm.specification = null;
          this.editForm.date = null;
          this.editForm.pdyj = null;
          this.editForm.jconclusion = null;

      },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let params = new FormData();
          params.append("id",row.reportNumber)
          // let params = {"id":row.reportNumber};
          delReport(params)
            .then(res => {
              if (res.code == 0) {
                this.$message({
                  type: 'success',
                  message: '报告已删除!'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('报告删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editForm= {
        samplesNumber: '',
          reportNumber: '',
          unit: '',
          projectName: '',
          samplesNmae: '',
          specification: '',
          date: '',
          pdyj: '',
          jconclusion: ''
      }
    },
    //关闭二维码
    closeDialogCode(){
      this.qrcode1 = false;
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}


</style>





// WEBPACK FOOTER //
// src/views/report/reportList.vue